import React from 'react'
import BaseComponent, { errorMap } from './BaseComponent'
import { NavLink } from 'react-router-dom'
import Modal from './Modal'
import _ from 'lodash'
import ReactPaginate from 'react-paginate';
import { parseDate } from './BaseComponent'

export default class ListPage extends BaseComponent {

  constructor(props) {
    super(props)
    this.state = { list: [], itemId: null, preloader: true, searchTerm: "", searchBy: _.filter(this.props.data.fields, { type: "text" })[0].name, page: 0, pages: 0, category: "test", sortBy: "publicationDate", filters: {}, mapUUID: "" }
    this._bind('delete', 'getData', 'searchUpdated', 'closeConfirm', 'handlePageClick')

    this.handleSearch = _.debounce( () => {
      this.setState({ list: [], preloader: true })
      this.getData(this.state.mapUUID)
    }, 600);
  }

  getData(mapUUID) {
    let url = this.props.API+this.props.data.endpointList
    let params = {
      query: this.state.searchTerm,
      sort: this.state.searchBy,
      order: this.state.order,
      offset: this.state.page*20,
      limit: 20,
      archived: false
    }

    if(this.props.data.table === "address") {
      params.map = { uuid: mapUUID }
    }

    fetch(url, {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer " + sessionStorage.getItem('token')
        },
        body: JSON.stringify(params)
      })
    .then((response) => {
        return response.json()
    })
    .then((result) => {
      if (!result.status.success) {
        window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : errorMap(result.data?.error?.ident || result.data?.error)}}), true);
      } else {
        //console.log(result)
        let res = result.data[this.props.data.content] || result.data || []
        if (res === null) {
          res = []
        }
        const ordered = res
        this.setState({ pages: Math.ceil(result.data.count/20) })
        this.setState({ list: ordered, preloader: false })
      }
    }, (error) => {
      console.log(error)
    })
  }

  getLatestMap() {
    let url = this.props.API+"/map/list"
    let params = {
      offset: 0,
      limit: 20
    }

    fetch(url, {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer " + sessionStorage.getItem('token')
        },
        body: JSON.stringify(params)
      })
    .then((response) => {
        return response.json()
    })
    .then((result) => {
      if (!result.status.success) {
        window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : errorMap(result.data?.error?.ident)}}), true);
      } else {
        const geocoded = _.filter(result.data, {geocoded: true})
        const lastMap = geocoded[0]
        console.log(lastMap)
        this.setState({ mapUUID: lastMap?.uuid })
        this.getData(lastMap?.uuid)
      }
    }, (error) => {
      console.log(error)
    })
  }

  componentDidMount() {
    if(this.props.data.table === "address") {
      this.getLatestMap()
    } else {
      this.getData()
    }
  }

  delete(id) {
    this.setState({ preloader: true })
    let url = this.props.API+this.props.data.endpointDelete
    const params = {
      [this.props.data.table]: {
        uuid: id
      }
    }
    fetch(url, {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer " + sessionStorage.getItem('token')
      },
      body: JSON.stringify(params)
    })
    .then((response) => {
        return response.json()
    })
    .then((result) => {
      //console.log(result)
      this.setState({ confirm: false, itemId: null })
      this.getData()
      if (!result.status.success) {
        window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : errorMap(result.data?.error?.ident || result.data?.error)}}), true);
      } else {
        window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "green", 'content' : "Pomyślnie usunięto."}}), true);
      }
    }, (error) => {
      console.log(error)
      window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : "Something went wrong."}}), true);
      this.setState({ preloader: false })
    })
  }

  searchUpdated(term) {
    this.setState({searchTerm: term})
  }

  closeConfirm() {
    this.setState({ confirm: false, itemId: null })
  }

  handlePageClick(data) {
    this.setState({ page: data.selected, preloader: true }, () => {
      this.getData(this.state.mapUUID)
    })
  }

  render () {
    let list = null

    let filteredList = this.state.list

    const Confirm = (
      <div className="confirm">
        <h4>Are you sure?</h4>
        <div className="btn-holder">
          <button className="btn" onClick={ this.closeConfirm }><span>No</span></button>
          <button className="btn" onClick={ this.delete.bind(null, this.state.itemId) }><span>Yes</span></button>
        </div>
      </div>
    )

    if (filteredList?.length > 0) {
      const sortedList = this.props.data.table === "articles" || this.props.data.table === "offers" || this.props.data.table === "events" || this.props.data.table === "faq" ? _.orderBy(filteredList, [this.state.sortBy], ['desc']) : filteredList
      list = sortedList.map((item, i) => {
        return (
          <li key={ i }>
            <div className="date">
              { item.created?.date ? <span><strong>Created:</strong> { parseDate(item.created?.date, true, true) }<br/></span> : null }
              { item.updated?.date ? <span><strong>Edited:</strong> { parseDate(item.updated?.date, true, true) }<br/></span> : null }
              { item.publicationDate ? <span><strong>Publish date:</strong> { parseDate(item.publicationDate, true, true) }</span> : null }
            </div>
            { item.image ? <div className="thumb">
              <img src={ item.image } alt=""/>
            </div> : null }
            { item.ident && <NavLink to={ this.props.data.route + "/" + item.uuid } style={{ textDecoration: "none" }}><h4>Ident: { item.ident }</h4></NavLink> }<br/>            
            { item.emailAddress ? <NavLink to={ this.props.data.route + "/" + item.emailAddress } style={{ textDecoration: "none" }}><h4 className={ item.image ? "withimg" : "" }><span>E-mail: </span>{item.emailAddress}</h4></NavLink> : <NavLink to={ this.props.data.route + "/" + item.uuid } style={{ textDecoration: "none" }}><h4 className={ item.image ? "withimg" : "" }>{ this.props.data.table === "faq" ? <span>Category: { item.categoryName }<br/></span> : null }Name: { item.content?.title ? item.content.title : item.title ? item.title : item.firstName ? item.firstName + " " + item.lastName + " - " + item.group : item.name }</h4></NavLink> }
            { item.priority || item.priority === 0  ? <p>Priority: { item.priority }</p> : null }
            <div className="controls">
              { (this.props.user.role === "ADMIN" || this.props.user.role === "Moderator") && (this.props.data.route !== "/tracks" || item.in_use === false ) && this.props.data.delete ? <div onClick={ () => { this.setState({ confirm: true, itemId: item.uuid }) } }><img src="/assets/img/icons/delete.png" alt=""/><span>{ this.props.data.delete }</span></div> : null }
              { this.props.data.editLink ? <div><NavLink to={ this.props.data.route + "/" + item.uuid }><img src="/assets/img/icons/edit.png" alt=""/><span>{ this.props.data.edit }</span></NavLink></div> : <div><NavLink to={ this.props.data.route + "/" + item.uuid }><img src="/assets/img/icons/edit.png" alt=""/><span>View</span></NavLink></div> }
            </div>
          </li>
        )
      })
    }

    return (
      <section className="list">
        <div className="container">
    			<h1>{ this.props.data.name }</h1>
          { (this.props.user.role === "ADMIN" || this.props.user.role === "Moderator") && this.props.data.new  ? <NavLink to={ this.props.data.new } className="btn"><span>{ this.props.data.add }</span></NavLink> : null }
          {/* <div className="search-box">
            <div className="search-input si-select">
              <label htmlFor="searchBy">Search by:</label>
              <select id="searchBy" name="searchBy" value={ this.state.searchBy } onChange={ (e) => { this.setState({ searchBy: e.target.value }) } }>
                { _.filter(this.props.data.fields, { type: "text" }).map((item, i) => {
                  return (
                    <option key={ i } value={ item.name }>{ item.placeholder }</option>
                  )
                }) }
              </select>
            </div>
            <div className="search-input">
              <input type="text" placeholder="Type to search" value={ this.state.searchTerm } onChange={ (e) => { this.setState({ searchTerm: e.target.value }) } }/>
            </div>
            { this.props.data.table === "articles" || this.props.data.table === "offers" || this.props.data.table === "events" || this.props.data.table === "faq" ? <div className="sort">
              <label htmlFor="searchBy">Sort by:</label>
              <select id="sortBy" name="sortBy" value={ this.state.sortBy } onChange={ (e) => { this.setState({ sortBy: e.target.value }) } }>
                <option value="publicationDate">Publish date</option>
                <option value="updated">Edit date</option>
              </select>
            </div> : null }
          </div> */}
          { this.state.pages > 0 ? <ReactPaginate
            previousLabel={'<'}
            nextLabel={'>'}
            breakLabel={'...'}
            breakClassName={'break-me'}
            pageCount={this.state.pages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={ this.handlePageClick }
            containerClassName={'pagination'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
            forcePage={ this.state.page }
          /> : null }
          <ul className="list-items" style={(this.props.data.content === "activation" || this.props.data.content === "campaign") && this.props.screen.width > 720 ? {marginTop: "100px"} : {}}>
            { filteredList?.length > 0 ? list : <h5>No results!</h5> }
            { this.state.preloader ? <div className="preloader"><span></span></div> : null }
          </ul>
          { this.state.pages > 0 ? <ReactPaginate
            previousLabel={'<'}
            nextLabel={'>'}
            breakLabel={'...'}
            breakClassName={'break-me'}
            pageCount={this.state.pages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={ this.handlePageClick }
            containerClassName={'pagination'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
            forcePage={ this.state.page }
          /> : null }
	  	  </div>
        <Modal open={ this.state.confirm } hidePopup={ this.closeConfirm }>{ Confirm }</Modal>
      </section>
    )
  }
}
